import {FooterPaymentComponent} from "shared/components/footer/footer-payment/footer-payment.component";

export const AppConfigs = {
  homePage:{
    whyChooseUs:{
      titre1:"Votre partenaire de confiance",
      text1 :"La <strong>SIMPLICITÉ</strong> est une valeur ancrée de Imtech, pour\n" +
        "        nous, la simplicité est l’habit de la <strong>PERFECTION</strong>.\n" +
        "        Choisir Imtech, c’est choisir la <strong>CONFIANCE</strong>, une valeur\n" +
        "        essentielle pour Imtech, qui vous garantit d’avoir les meilleurs\n" +
        "        produits, aux meilleurs prix, nous accordons une importance toute\n" +
        "        particulière à notre personnel, à nos technologies mais surtout à nos\n" +
        "        clients.<br/>\n" +
        "        Faites partie de l'<strong>INNOVATION</strong> qui a du sens. En nous\n" +
        "        choisissant, vous ne rejoindrez pas seulement un univers, vous y\n" +
        "        apporterez le vôtre.",
      titre2:"Besoin d’un conseil ?",
      secondText : "      Choisir <strong>IMTECH</strong> c’est un accès direct au produit entre\n" +
        "        bon sens et intelligence, minimiser les choix, et faciliter votre\n" +
        "        décision.<br/><br/>\n" +
        "        La simplicité se retrouve à chaque étape chez IMTECH : de la sélection\n" +
        "        du produit, à la vente en passant par l’optimisation du parcours client.\n" +
        "        Tout cela constitue une expérience optimisée pour vous.",
      buttonsend:"        BESOIN D’UN CONSEIL\n"
    }
  },
  Footer:{
    title:"PAIEMENT",
    lienU:"LIENS UTILES",
    actual:"      Actualités\n",
    mention:"Mentions légales",
    condition:"      Conditions générales\n",
    coukies:"      Les Cookies sur Imtech\n",
    securite:     "        Sécurité et confidentialité"
  },
  menu:{
    categorie:"Catégories",
    Actual:"Actualités",
    qst:"Foire aux questions",
    quiSommeNous:"Qui sommes-nous?"

  },
  home:{
    title1:"nos Promotions",
    title2:"les plus vendus",
    titre3:"POURQUOI CHOISIR Imtech" ,
    title4:"Marques Distribuées",
    title5:"Nouvel Arrivage",
    title6:"Déstockage"

  },
  clientService:{
    general:"Général",
    soustext:"Questions fréquentes que vous pourriez vous poser",
    order:"Commandes",
    sousText2:"Questions en rapport avec votre commande",
    payment:"Paiement",
    soustext3:"Questions sur le paiement",
    livraison:"Livraison",
    soustext4:"Méthode et temps de livraison",
    poserQst:"Poser votre question"
  },
  About:{
    Apropos:"A PROPOS DE Imtech",
    sousTextApro:" La simplicité est une grande valeur chez IMTECH. Pour nous, elle est\n" +
      "        l’habit de la perfection. Choisir IMTECH, c’est choisir la confiance et\n" +
      "        la sérénité qui sont essentielles pour nous. Nous vous garantissons les\n" +
      "        meilleurs produits, au meilleur prix et nous accordons une importance\n" +
      "        toute particulière à notre personnel, nos technologies, mais surtout nos\n" +
      "        clients. Rejoignez l’aventure IMTECH et contribuer à l’innovation !",
    histoire:"NOTRE HISTOIRE",
    des1:"  IMTECH est une entreprise française. Distributeur des produits et services informatiques en\n" +
      "        BtoB et BtoC. L'entreprise importe et exporte des appareils et solutions\n" +
      "        informatiques, téléphoniques........",
    des2:"LES VALEURS DE IMTECH",
    des3:" IMTECH attache une grande importance à la satisfaction de ses clients, nous\n" +
      "    cherchons à respecter ces valeurs en tout temps, dans chacun de nos contacts\n" +
      "    avec les clients. IMTECH promet à chaque client :",
    des4:"Un contact personnel",
    des5:"  IMTECH attache une grande valeur à sa relation avec le client. Tout le\n" +
      "        monde peut nous joindre par le biais de la boutique en ligne, par\n" +
      "        téléphone, par courriel, voire grâce à une visite personnelle de l’un de\n" +
      "        nos Account Managers. En tant que client, vous avez votre propre\n" +
      "        interlocuteur qui vous aide dans tous vos achats, vos questions et vos\n" +
      "        problèmes, quelle que soit leur importance. En résumé : nous promettons\n" +
      "        à chacun un traitement VIP !",
    des6:"        Flexibilité et rapidité           \n",
    des7:" Chez IMTECH, nous promettons d’être flexibles lorsque vous en avez besoin.\n" +
      "        Notre petite structure et l’expertise de notre personnel nous permettent de\n" +
      "        répondre rapidement à toutes vos questions qu'importe leur sujet\n" +
      "        (produit, une livraison spéciale, un support technique, une offre spéciale ou un autre problème).",
    des8:"Un service sur mesure",
    des9:"Chez IMTECH, nous comprenons que chaque client a des besoins\n" +
      "        spécifiques en matière d’information, de traitement des commandes, de\n" +
      "        solutions logistiques, de stock, de gestion des livraisons différées et\n" +
      "        de rapports, nous allons beaucoup plus loin pour vous qu’un simple\n" +
      "        distributeur. Et nous promettons de le faire pour toutes nos marques.\n" +
      "        Notre travail ne s’arrête pas à la réception de commandes. Nous vous\n" +
      "        aidons dans vos recherches et vos prises de décision tout en recherchant\n" +
      "        une relation gagnant-gagnant.",
    des10:"Une logistique qualitative et proactive",
    des11:"          Chez IMTECH, nous promettons des livraisons ponctuelles, meilleures de\n" +
      "        jour en jour. Nous recherchons l’excellence, la flexibilité et la\n" +
      "        proactivité en cas de problème. Nous voulons développer un processus de\n" +
      "        distribution solide pour conserver un stock important et disposer d’un\n" +
      "        assortiment aussi varié que possible.",
    title2:"SUR IMTECH ET<br />\n" +
      "        PROFITEZ DE NOS OFFRES",
    btnConnect:"        Se connecter / s'inscrire\n"

  },
  cart:{
    panier:"PANIER",
    equipe:"L'équipe IMTECH",
    equipeDes:"est à votre service si vous avez\n" +
      "    besoin d’aide.",
    suiteEmptyCart:" est à votre service si vous avez\n" +
      "    besoin d’aide.",
    devisVide:" Vous n'avez aucun devis.",
    panierVide:"   Votre panier est vide.",
    partenaire:"Votre partenaire de confiance"
  }
};
